// frontend/src/hooks/useP2PStats.ts
import { useQuery } from '@tanstack/react-query';
import { api as apiClient } from '../lib/api';
import { P2P_PAIR } from '../lib/p2p/tokens';

export function useP2PStats(pair: string = P2P_PAIR) {
  return useQuery({
    queryKey: ['p2p', 'stats', pair],
    queryFn: () => apiClient.getP2PStats(pair),
    refetchInterval: 30_000,
  });
}
